import React from 'react';
import { Form, Formik, FormikProps } from 'formik';
import { AxiosError } from 'axios';
import get from 'lodash/get';

import { yup as yupCreator } from 'services';

import * as Api from '../api';
import * as Types from '../types';

interface FormValues extends Types.IForm.Prepayment {}

interface IProps {
  applicationId?: number;
  registerId?: number;
  serial: string;
  language: string;
  onSuccess?: (phone: string) => void;
  onError?: (message: string) => void;
  onFinally?: () => void;

  children(props: FormikProps<FormValues>): JSX.Element;
}

const Prepayment: React.FC<IProps> = ({ applicationId, registerId, serial, language, onSuccess = () => {}, onError = () => {}, onFinally = () => {}, children }) => {

  const yup = yupCreator();
  const validationSchema = (
    yup.object().shape<FormValues>({
      card: yup.object().shape({
        number: yup.string().min(16).required(),
        expires: yup.string().min(4).required()
      }).required()
    })
  );

  const handleSubmit = (values: FormValues, { isSubmitting, setSubmitting }: FormikProps<FormValues>) => {
    if(isSubmitting){
      return;
    }

    Api.Prepayment({ applicationId, registerId, serial, language, values })
      .then((({ data }) => onSuccess(get(data, 'data.phone_number') || '')))
      .catch((e) => {
        const response = e as AxiosError;
        const message = response?.response?.data?.status_message;
        setSubmitting(false);
        onError(message)
      })
      .finally(() => onFinally())
  };

  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={{
        card: {
          number: '',
          expires: ''
        }
      }}
      validateOnMount
      validateOnChange
      {...{ validationSchema }}
    >
      {(props: FormikProps<FormValues>) => (
        <Form>
          {children(props)}
        </Form>
      )}
    </Formik>
  );
};

export default Prepayment;